// extracted by mini-css-extract-plugin
export default {"root":"root__p57up","fadeInAnimation":"fadeInAnimation__DHxpP","heading":"heading__9f4XN","hideContent":"hideContent__MdTiC","fadeOutAnimation":"fadeOutAnimation__k0xmN"};